<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_contract_condition') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="name" class="required">Name</label>
                        <app-input 
                            :placeholder = "$t('Name')" 
                            type = "text"
                            v-model = "name" 
                            :required = "true"  
                        />
                        <br>
                        <label for="name" class="required">Description</label>
                        <app-input  type="text-editor" v-model="description" :minimal="true" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "AddProductCondittion",
    data() {
        return {
            name: "",
            description : "",
        };
    },
    methods: {
        submit() {
            this.$emit("save", this.name, this.description);
        },
    },
};
</script>
  